var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"teatree"},[_c('div',_vm._l((_vm.roots),function(node,index){return _c('node',{key:index,attrs:{"node":node},scopedSlots:_vm._u([{key:"node-toggle",fn:function(ref){
var node = ref.node;
return [_vm._t("node-toggle",null,{"node":node})]}},{key:"node-name",fn:function(ref){
var node = ref.node;
return [_vm._t("node-name",null,{"node":node})]}}],null,true)})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }